import { FC } from 'react';
import AddOwnerButton from '../components/ApplicationCard/AddOwnerButton';

const AddOwnerButtonContainer: FC<
  React.PropsWithChildren<AddOwnerButtonContainerProps>
> = ({ onAddOwners }) => {
  return <AddOwnerButton onClick={onAddOwners} />;
};

export interface AddOwnerButtonContainerProps {
  onAddOwners: () => void;
}

export default AddOwnerButtonContainer;
